import { openUrl } from '@tauri-apps/plugin-opener';
import { checkTauriPresentSync } from './isDesktop';

export const openLink = async (url) => {
  if (checkTauriPresentSync()) {
    await openUrl(url);
  } else {
    window.open(url, '_blank');
  }
};
